

















































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import SearchInput from '@shared/components/forms/inputs/search-input.vue';
import MultiSelect from '@shared/components/forms/inputs/multi-select/multi-select.vue';
import { DateRangeInterface, SelectOptionInterface } from '@shared/interfaces/inputs';
import { PosSessionSyncDefaultFilterTableInterface } from '@modules/accounting-integrations/interfaces/pos-session-sync';
import DatePicker from 'vue2-datepicker';
@Component({
  name: 'bc-sale-days-sync-filters',
  components: {
    'bpc-search-input': SearchInput,
    'bpc-multi-select': MultiSelect,
    DatePicker,
  },
})
export default class PosSessionSyncFilters extends Vue {
  @Prop({ type: Object, required: true })
  readonly value!: PosSessionSyncDefaultFilterTableInterface;
  @Prop({ type: Function, required: true }) readonly clickOnReload!: () => void;

  dateRange: DateRangeInterface = {
    start_date: null,
    end_date: null,
  };
  get model(): PosSessionSyncDefaultFilterTableInterface {
    return this.value;
  }

  set model(value: PosSessionSyncDefaultFilterTableInterface) {
    this.$emit('input', value);
  }

  get hideInputLabel() {
    return {
      labelAttributes: { for: 'input' },
    };
  }

  get syncStatusOptions(): SelectOptionInterface[] {
    return [
      {
        value: 'pending',
        text: this.$t(
          'accounting_integrations.sale_days_sync.sync_status.to_process.label',
        ).toString(),
      },
      {
        value: 'synced',
        text: this.$t('accounting_integrations.sale_days_sync.sync_status.synced.label').toString(),
      },
      {
        value: 'failed',
        text: this.$t('accounting_integrations.sale_days_sync.sync_status.failed.label').toString(),
      },
    ];
  }

  get validationStatusOptions(): SelectOptionInterface[] {
    return [
      {
        value: 'opened',
        text: this.$t(
          'accounting_integrations.sale_days_sync.validation_status.opened.label',
        ).toString(),
      },
      {
        value: 'closed',
        text: this.$t(
          'accounting_integrations.sale_days_sync.validation_status.closed.label',
        ).toString(),
      },
    ];
  }
  @Watch('dateRange', { deep: true })
  onDateRangeChange() {
    this.model.date_from = this.dateRange.start_date;
    this.model.date_to = this.dateRange.end_date;
  }
}
